module.exports = __webpack_public_path__ + "static/img/shop5.c041f7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shop5.png
// module id = CsH+
// module chunks = 2